// A screen's back button: one step back through the app's own history, or — when the screen was opened straight from a
// link or a bookmark (nothing to go back to) — to the given place.
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useBack(fallback: string) {
  const nav = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) nav(-1);
    else nav(fallback);
  }, [nav, fallback]);
}
